export const parseApiDateTime = (value?: string | null): Date | null => {
  if (!value || typeof value !== 'string') return null;

  // Handle backend format like "2026-03-27 10:11:11" as local time.
  const match = value.match(
    /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/
  );

  if (match) {
    const [, y, m, d, hh, mm, ss] = match;
    return new Date(
      Number(y),
      Number(m) - 1,
      Number(d),
      Number(hh),
      Number(mm),
      Number(ss || '0')
    );
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatApiDateTimeForDisplay = (value?: string | null): string => {
  if (!value || typeof value !== 'string') return '-';

  // Keep DB/API clock time as-is (no timezone conversion).
  const match = value.match(
    /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/
  );

  if (!match) return value;

  const [, y, m, d, hh, mm, ss] = match;
  return `${d}.${m}.${y} ${hh}:${mm}:${ss || '00'}`;
};
